var _path, _g, _circle, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8151 3.45459H6.1221C5.76648 3.45459 5.42543 3.59586 5.17398 3.84732C4.92252 4.09877 4.78125 4.43982 4.78125 4.79544V15.5222C4.78125 15.8779 4.92252 16.2189 5.17398 16.4704C5.42543 16.7218 5.76648 16.8631 6.1221 16.8631H14.1672C14.5228 16.8631 14.8639 16.7218 15.1153 16.4704C15.3668 16.2189 15.5081 15.8779 15.5081 15.5222V8.14757L10.8151 3.45459Z",
    fill: "url(#paint0_linear_1389_9534)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1389_9534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8164 3.45459V7.5589C10.8164 7.88401 11.08 8.14757 11.4051 8.14757H15.5094",
    fill: "url(#paint1_linear_1389_9534)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.03962,
    cy: 11.0418,
    r: 2.649,
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3145 11.1399L8.25412 12.3294L8.25412 9.95038L10.3145 11.1399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.985 17.2227C14.985 17.2227 17.6536 15.8884 17.6536 13.8869V11.5519L14.985 10.5511L12.3164 11.5519V13.8869C12.3164 15.8884 14.985 17.2227 14.985 17.2227Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.985 17.2227C14.985 17.2227 17.6536 15.8884 17.6536 13.8869V11.5519L14.985 10.5511L12.3164 11.5519V13.8869C12.3164 15.8884 14.985 17.2227 14.985 17.2227Z",
    fill: "url(#paint2_linear_1389_9534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5078 13.3963L14.6851 14.5737L16.6474 12.6115",
    stroke: "white",
    strokeWidth: 0.588666,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1389_9534",
    x: 10.2277,
    y: 3.25837,
    width: 5.87069,
    height: 5.87033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.392444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.294333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1389_9534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1389_9534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9534",
    x1: 5.1939,
    y1: 4.17373,
    x2: 16.1524,
    y2: 17.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9534",
    x1: 10.9969,
    y1: 3.70629,
    x2: 14.5815,
    y2: 9.19391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF55F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#FF5252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1389_9534",
    x1: 14.985,
    y1: 10.5511,
    x2: 14.985,
    y2: 17.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon7);
export default __webpack_public_path__ + "static/media/camera_card_icon7.999b11082b66ff2e8f74777879dbbfca.svg";
export { ForwardRef as ReactComponent };